var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CountHeader',{attrs:{"header":"แก้ไขข้อมูลรอบนับสต๊อก","img_header":_vm.header_image,"link_back":"count_stock/historylist"}}),_c('Count_Edit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }